import { Injectable, inject } from '@angular/core';
import { AbstractSearchFacade } from '@pf/shared-services';
import {
    UserPermissionDto,
    UserPermissionRead,
    UserPermissionCreate,
    UserPermissionSearchParams,
} from '../entities/user-permission.dto';
import { UserPermissionDataService } from '../infrastructure/user-permissions/user-permission.data.service';
import { UserPermissionMapper } from '../infrastructure/user-permissions/user-permission.mapper';
import { UserPermissionStore } from '../infrastructure/user-permissions/user-permission.store';
import { PermissionsService } from '@control-tower/platform-core';

@Injectable()
export class UserPermissionFacade extends AbstractSearchFacade<
    UserPermissionDto,
    UserPermissionRead,
    UserPermissionCreate,
    UserPermissionSearchParams
> {
    private permissionsService = inject(PermissionsService);

    nameField: keyof UserPermissionDto = 'permissionName';
    textSearchFilter(
        searchText: string
    ): Partial<Record<keyof UserPermissionDto, string>> {
        return { permissionName: searchText };
    }

    constructor() {
        const dataService = inject(UserPermissionDataService);
        const store = inject(UserPermissionStore);
        const mapper = inject(UserPermissionMapper);

        super(dataService, store, mapper);
    }

    getAllPermissions$() {
        return this.permissionsService.v1PermissionsGet();
    }
}
